import images from "../../../assets";

export default function OnlineNowUserColumn(props) {
  return (
    <div
      {...props}
      className="w-full border-b border-[#cccbcb] justify-start items-start inline-flex"
    >
      <div className="w-full h-[68px] p-4 justify-start items-center gap-2 flex">
        <div className="justify-start items-center gap-2 flex">
          <img className="relative" src={props.profileimg} />
          <div className="pt-2 text-black text-sm font-normal  leading-tight">
            {props.name}
          </div>
        </div>
      </div>
      <div className="w-full self-stretch p-4 justify-center items-center gap-2 flex">
        <div className="w-6 h-6 relative">
          <img src={props.flag} />
        </div>
      </div>
      <div className="w-full self-stretch p-4 justify-center items-center gap-2 flex">
        <div className="text-[#222222] text-sm font-normal  leading-tight">
          {props.sessiontime}
        </div>
      </div>
      <div className="w-full self-stretch p-4 justify-center items-center gap-2 flex">
        <div className="text-right text-[#222222] text-sm font-normal  leading-tight">
          {props.date}
        </div>
      </div>
    </div>
  );
}
